import { render, staticRenderFns } from "./researchCard.vue?vue&type=template&id=4855bad0&scoped=true&"
import script from "./researchCard.vue?vue&type=script&lang=js&"
export * from "./researchCard.vue?vue&type=script&lang=js&"
import style0 from "./researchCard.vue?vue&type=style&index=0&id=4855bad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855bad0",
  null
  
)

export default component.exports